module.exports = __webpack_public_path__ + "static/img/14000057.2a9b2741.png";